import Swal from 'sweetalert2'
import {
  IconPaths,
  showAlert,
  showAlertLoading,
  showError,
} from '../../../../../../../_metronic/helpers'
import { Button } from '../../../../../../components'
import { getCsv, getPdf } from '../../../../relatorios/relatorio-list/core/_requests'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useAuth } from '../../../../../auth'

/** Exportação do relatório dos atendimentos filtrados (exige ao menos um filtro). */
export const PersonalAtendimentosListToolbar = () => {
  const { currentUser } = useAuth()
  const { state } = useQueryRequest()

  const exportar = async (formato: 'pdf' | 'csv') => {
    if (!state.search) {
      showAlert({
        title: 'Filtro necessário',
        text: 'Aplique ao menos um filtro antes de exportar o relatório.',
        icon: 'warning',
      })
      return
    }

    // A aba do PDF abre antes da requisição (senão o navegador bloqueia como pop-up).
    const novaAba = formato === 'pdf' ? window.open('', '_blank') : null
    const query = `search=responsavel.pessoa.id:${currentUser?.id},${state.search}`

    try {
      showAlertLoading()
      const { data } = await (formato === 'pdf' ? getPdf(query) : getCsv(query))
      Swal.close()
      if (novaAba) novaAba.location.replace(data.URL)
      else window.open(data.URL, '_blank')
    } catch (error) {
      novaAba?.close()
      showError(error)
    }
  }

  return (
    <>
      <Button variant='secondary-outline' icon={IconPaths.Pdf} onClick={() => exportar('pdf')}>
        Exportar PDF
      </Button>
      <Button variant='secondary-outline' icon={IconPaths.Csv} onClick={() => exportar('csv')}>
        Exportar CSV
      </Button>
    </>
  )
}
